import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SmallText } from '../Text';
import { StyledBreadcrumbAnchor } from './Breadcrumb.styled';
export function Breadcrumb(props) {
  return /*#__PURE__*/React.createElement(StyledBreadcrumbAnchor, _extends({}, getBreadcrumbElementProps(props), {
    isActive: props.isActive,
    forceEllipsisOnActive: props.forceEllipsisOnActive
  }), /*#__PURE__*/React.createElement(SmallText, {
    display: "inline"
  }, props.title));
}
export function getBreadcrumbElementProps(props) {
  var elementProps = {
    title: props.title,
    href: props.href,
    target: props.target
  };
  if (props.isActive) {
    elementProps['aria-current'] = 'page';
  }
  if (props.target === '_blank') {
    elementProps.rel = 'noopener noreferrer';
  }
  if (props.onClick || props.isActive) {
    elementProps.onClick = function (e) {
      e.preventDefault();
      !props.isActive && props.onClick && props.onClick(props, e);
    };
  }
  return elementProps;
}